import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-payment-declined',
  templateUrl: './payment-declined.component.html',
  styleUrls: ['./payment-declined.component.scss']
})
export class PaymentDeclinedComponent implements OnInit {

  @Input() public title;
  @Input() public message;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }
}
